import { FeatureFlags } from './types';

export enum FeatureFlag {
  fluidBrowse = 'fluidBrowse',
  visualCategoryBrowse = 'visualCategoryBrowse',
  priceSort = 'priceSort',
}

export const featureFlagDefaults: Required<FeatureFlags> = {
  [FeatureFlag.fluidBrowse]: false,
  [FeatureFlag.visualCategoryBrowse]: false,
  [FeatureFlag.priceSort]: false,
};
